export default __webpack_public_path__ + "static/media/Group 1403.ccdcecb8.png";